import Link from "next/link";

const CLink = ({ children, ...props }) => {
  const newProps = Object.assign({}, props);
  if (newProps.href) {
    newProps.href = newProps.href + (process.env.NEXT_PUBLIC_LINK_EXT || "");
  }
  return <Link {...newProps}>{children}</Link>;
};

export default CLink;
